var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fab = void 0;
var Fab_1 = __importDefault(require("./Fab"));
exports.Fab = Fab_1.default;
exports.default = Fab_1.default;
//# sourceMappingURL=index.js.map